@let hasErrorValue = hasError();

<rt-box layout-vertical [class.rating-advanced-field__box--invalid]="hasErrorValue">
  <rt-evaluation-rating-field
    [control]="ratingControl()"
    [ratingScale]="ratingScale()"
    [hasBox]="false"
    [showValidationErrors]="false"
  />

  @if (commentExpanded()) {
    <rt-evaluation-comment-field
      [control]="commentControl()"
      [jsonControl]="commentJsonControl()"
      [hasBox]="false"
      margin-top-small
    />
  } @else {
    <rt-button
      class="rating-advanced-field__add-comment"
      variant="plain"
      margin-top-small
      (click)="expandComment()"
    >
      <rt-icon name="add" />
      {{ 'app.evaluation_panel.add_comment' | translate }}
    </rt-button>
  }
</rt-box>

@if (hasErrorValue) {
  <div class="rating-advanced-field__error">
    {{ 'app.evaluation_panel.errors.basic_required' | translate }}
  </div>
}
